export default "__VITE_ASSET__cafa84dc__"